import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Nom du passagers "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Numéro Téléphone "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_5 = { class: "flex flex-row space-x-1" }
const _hoisted_6 = { class: "flex flex-col w-1/2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Type Pièce "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_8 = { class: "flex flex-col w-1/2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode(" N° pièce d'identification "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_10 = { class: "flex flex-row items-end justify-end w-full space-x-4" }


export default /*#__PURE__*/_defineComponent({
  __name: 'PassengerEditModal',
  props: {
    open: { type: Boolean },
    name: {},
    isLoading: { type: Boolean },
    passenger: {},
    validations: {},
    identityTypeCards: {}
  },
  emits: ["close", "update:first_name", "update:phone", "update:identity_type_card_id", "update:identity_no", "update:ticket_date", "submit"],
  setup(__props: any) {

	/**
	 * Passenger identity edit modal — extracted from NewPassenger.vue.
	 *
	 * State stays in the parent (single source of truth); the modal only binds
	 * inputs to the model via @model emits and surfaces validation messages.
	 */
	
	

return (_ctx: any,_cache: any) => {
  const _component_InputTag = _resolveComponent("InputTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_ButtonTag = _resolveComponent("ButtonTag")!
  const _component_ModalPage = _resolveComponent("ModalPage")!

  return (_ctx.open)
    ? (_openBlock(), _createBlock(_component_ModalPage, {
        key: 0,
        title: 'Mise à jour des Informations du passager',
        name: _ctx.name,
        styleContent: "w-full",
        styleFooter: "w-full",
        styleModal: '!w-2/6',
        onClose: _cache[6] || (_cache[6] = (e) => _ctx.$emit('close', e))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_InputTag, {
              placeholder: "Ex : Paul Martin",
              type: "text",
              onModel: _cache[0] || (_cache[0] = (e) => _ctx.$emit('update:first_name', e)),
              value: _ctx.passenger.first_name,
              error: _ctx.validations.first_name.message
            }, null, 8, ["value", "error"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputTag, {
              placeholder: "Ex : 699 99 99 99",
              type: "tel",
              onModel: _cache[1] || (_cache[1] = (e) => _ctx.$emit('update:phone', e)),
              value: _ctx.passenger.phone,
              error: _ctx.validations.phone.message
            }, null, 8, ["value", "error"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_SelectTag, {
                placeholder: "Sélectionner un Type Pièce",
                onModel: _cache[2] || (_cache[2] = (e) => _ctx.$emit('update:identity_type_card_id', e.key)),
                selected: String(_ctx.passenger.identity_type_card_id ?? 0),
                error: _ctx.validations.identity_type_card_id.message,
                data: JSON.stringify(_ctx.identityTypeCards)
              }, null, 8, ["selected", "error", "data"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_InputTag, {
                placeholder: "Ex : LT20225565855858585",
                type: "text",
                onModel: _cache[3] || (_cache[3] = (e) => _ctx.$emit('update:identity_no', e)),
                value: _ctx.passenger.identity_no,
                error: _ctx.validations.identity_no.message
              }, null, 8, ["value", "error"])
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_ButtonTag, {
              label: "Annuler",
              activeIcon: false,
              icon: "/media/icons/add-icon.svg",
              css: "bg-gray-500 border-secondary text-white px-6 py-2 hover:bg-gray-600 w-full active:bg-gray-500 focus:outline-none",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close', _ctx.name)))
            }),
            _createVNode(_component_ButtonTag, {
              label: "Valider les changements",
              activeIcon: false,
              icon: "/media/icons/add-icon.svg",
              loader: _ctx.isLoading,
              "text-loading": 'Validation en cours...',
              css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152] focus:outline-none",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('submit')))
            }, null, 8, ["loader"])
          ])
        ]),
        _: 1
      }, 8, ["name"]))
    : _createCommentVNode("", true)
}
}

})